// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.1
// source: rendezvous.proto

/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "hbb";

export enum ConnType {
  DEFAULT_CONN = 0,
  FILE_TRANSFER = 1,
  PORT_FORWARD = 2,
  RDP = 3,
  VIEW_CAMERA = 4,
  TERMINAL = 5,
  UNRECOGNIZED = -1,
}

export function connTypeFromJSON(object: any): ConnType {
  switch (object) {
    case 0:
    case "DEFAULT_CONN":
      return ConnType.DEFAULT_CONN;
    case 1:
    case "FILE_TRANSFER":
      return ConnType.FILE_TRANSFER;
    case 2:
    case "PORT_FORWARD":
      return ConnType.PORT_FORWARD;
    case 3:
    case "RDP":
      return ConnType.RDP;
    case 4:
    case "VIEW_CAMERA":
      return ConnType.VIEW_CAMERA;
    case 5:
    case "TERMINAL":
      return ConnType.TERMINAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConnType.UNRECOGNIZED;
  }
}

export function connTypeToJSON(object: ConnType): string {
  switch (object) {
    case ConnType.DEFAULT_CONN:
      return "DEFAULT_CONN";
    case ConnType.FILE_TRANSFER:
      return "FILE_TRANSFER";
    case ConnType.PORT_FORWARD:
      return "PORT_FORWARD";
    case ConnType.RDP:
      return "RDP";
    case ConnType.VIEW_CAMERA:
      return "VIEW_CAMERA";
    case ConnType.TERMINAL:
      return "TERMINAL";
    case ConnType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum NatType {
  UNKNOWN_NAT = 0,
  ASYMMETRIC = 1,
  SYMMETRIC = 2,
  UNRECOGNIZED = -1,
}

export function natTypeFromJSON(object: any): NatType {
  switch (object) {
    case 0:
    case "UNKNOWN_NAT":
      return NatType.UNKNOWN_NAT;
    case 1:
    case "ASYMMETRIC":
      return NatType.ASYMMETRIC;
    case 2:
    case "SYMMETRIC":
      return NatType.SYMMETRIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NatType.UNRECOGNIZED;
  }
}

export function natTypeToJSON(object: NatType): string {
  switch (object) {
    case NatType.UNKNOWN_NAT:
      return "UNKNOWN_NAT";
    case NatType.ASYMMETRIC:
      return "ASYMMETRIC";
    case NatType.SYMMETRIC:
      return "SYMMETRIC";
    case NatType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface RegisterPeer {
  id: string;
  serial: number;
}

export interface RegisterPeerResponse {
  request_pk: boolean;
}

export interface PunchHoleRequest {
  id: string;
  nat_type: NatType;
  licence_key: string;
  conn_type: ConnType;
  token: string;
  version: string;
  udp_port: number;
  force_relay: boolean;
  upnp_port: number;
  socket_addr_v6: Uint8Array;
  switch_code: string;
}

export interface ControlPermissions {
  permissions: number;
}

export enum ControlPermissions_Permission {
  keyboard = 0,
  remote_printer = 1,
  clipboard = 2,
  file = 3,
  audio = 4,
  camera = 5,
  terminal = 6,
  tunnel = 7,
  restart = 8,
  recording = 9,
  block_input = 10,
  remote_modify = 11,
  privacy_mode = 12,
  UNRECOGNIZED = -1,
}

export function controlPermissions_PermissionFromJSON(object: any): ControlPermissions_Permission {
  switch (object) {
    case 0:
    case "keyboard":
      return ControlPermissions_Permission.keyboard;
    case 1:
    case "remote_printer":
      return ControlPermissions_Permission.remote_printer;
    case 2:
    case "clipboard":
      return ControlPermissions_Permission.clipboard;
    case 3:
    case "file":
      return ControlPermissions_Permission.file;
    case 4:
    case "audio":
      return ControlPermissions_Permission.audio;
    case 5:
    case "camera":
      return ControlPermissions_Permission.camera;
    case 6:
    case "terminal":
      return ControlPermissions_Permission.terminal;
    case 7:
    case "tunnel":
      return ControlPermissions_Permission.tunnel;
    case 8:
    case "restart":
      return ControlPermissions_Permission.restart;
    case 9:
    case "recording":
      return ControlPermissions_Permission.recording;
    case 10:
    case "block_input":
      return ControlPermissions_Permission.block_input;
    case 11:
    case "remote_modify":
      return ControlPermissions_Permission.remote_modify;
    case 12:
    case "privacy_mode":
      return ControlPermissions_Permission.privacy_mode;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ControlPermissions_Permission.UNRECOGNIZED;
  }
}

export function controlPermissions_PermissionToJSON(object: ControlPermissions_Permission): string {
  switch (object) {
    case ControlPermissions_Permission.keyboard:
      return "keyboard";
    case ControlPermissions_Permission.remote_printer:
      return "remote_printer";
    case ControlPermissions_Permission.clipboard:
      return "clipboard";
    case ControlPermissions_Permission.file:
      return "file";
    case ControlPermissions_Permission.audio:
      return "audio";
    case ControlPermissions_Permission.camera:
      return "camera";
    case ControlPermissions_Permission.terminal:
      return "terminal";
    case ControlPermissions_Permission.tunnel:
      return "tunnel";
    case ControlPermissions_Permission.restart:
      return "restart";
    case ControlPermissions_Permission.recording:
      return "recording";
    case ControlPermissions_Permission.block_input:
      return "block_input";
    case ControlPermissions_Permission.remote_modify:
      return "remote_modify";
    case ControlPermissions_Permission.privacy_mode:
      return "privacy_mode";
    case ControlPermissions_Permission.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ControlledContext {
  conn_audit_ref: string;
}

export interface PunchHole {
  socket_addr: Uint8Array;
  relay_server: string;
  nat_type: NatType;
  udp_port: number;
  force_relay: boolean;
  upnp_port: number;
  socket_addr_v6: Uint8Array;
  control_permissions: ControlPermissions | undefined;
  controlled_context: ControlledContext | undefined;
}

export interface TestNatRequest {
  serial: number;
}

/** per my test, uint/int has no difference in encoding, int not good for negative, use sint for negative */
export interface TestNatResponse {
  port: number;
  /** for mobile */
  cu: ConfigUpdate | undefined;
}

export interface PunchHoleSent {
  socket_addr: Uint8Array;
  id: string;
  relay_server: string;
  nat_type: NatType;
  version: string;
  upnp_port: number;
  socket_addr_v6: Uint8Array;
}

export interface RegisterPk {
  id: string;
  uuid: Uint8Array;
  pk: Uint8Array;
  old_id: string;
  no_register_device: boolean;
}

export interface RegisterPkResponse {
  result: RegisterPkResponse_Result;
  keep_alive: number;
}

export enum RegisterPkResponse_Result {
  OK = 0,
  UUID_MISMATCH = 2,
  ID_EXISTS = 3,
  TOO_FREQUENT = 4,
  INVALID_ID_FORMAT = 5,
  NOT_SUPPORT = 6,
  SERVER_ERROR = 7,
  NOT_DEPLOYED = 8,
  UNRECOGNIZED = -1,
}

export function registerPkResponse_ResultFromJSON(object: any): RegisterPkResponse_Result {
  switch (object) {
    case 0:
    case "OK":
      return RegisterPkResponse_Result.OK;
    case 2:
    case "UUID_MISMATCH":
      return RegisterPkResponse_Result.UUID_MISMATCH;
    case 3:
    case "ID_EXISTS":
      return RegisterPkResponse_Result.ID_EXISTS;
    case 4:
    case "TOO_FREQUENT":
      return RegisterPkResponse_Result.TOO_FREQUENT;
    case 5:
    case "INVALID_ID_FORMAT":
      return RegisterPkResponse_Result.INVALID_ID_FORMAT;
    case 6:
    case "NOT_SUPPORT":
      return RegisterPkResponse_Result.NOT_SUPPORT;
    case 7:
    case "SERVER_ERROR":
      return RegisterPkResponse_Result.SERVER_ERROR;
    case 8:
    case "NOT_DEPLOYED":
      return RegisterPkResponse_Result.NOT_DEPLOYED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RegisterPkResponse_Result.UNRECOGNIZED;
  }
}

export function registerPkResponse_ResultToJSON(object: RegisterPkResponse_Result): string {
  switch (object) {
    case RegisterPkResponse_Result.OK:
      return "OK";
    case RegisterPkResponse_Result.UUID_MISMATCH:
      return "UUID_MISMATCH";
    case RegisterPkResponse_Result.ID_EXISTS:
      return "ID_EXISTS";
    case RegisterPkResponse_Result.TOO_FREQUENT:
      return "TOO_FREQUENT";
    case RegisterPkResponse_Result.INVALID_ID_FORMAT:
      return "INVALID_ID_FORMAT";
    case RegisterPkResponse_Result.NOT_SUPPORT:
      return "NOT_SUPPORT";
    case RegisterPkResponse_Result.SERVER_ERROR:
      return "SERVER_ERROR";
    case RegisterPkResponse_Result.NOT_DEPLOYED:
      return "NOT_DEPLOYED";
    case RegisterPkResponse_Result.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PunchHoleResponse {
  socket_addr: Uint8Array;
  pk: Uint8Array;
  failure: PunchHoleResponse_Failure;
  relay_server: string;
  nat_type?: NatType | undefined;
  is_local?: boolean | undefined;
  other_failure: string;
  feedback: number;
  is_udp: boolean;
  upnp_port: number;
  socket_addr_v6: Uint8Array;
}

export enum PunchHoleResponse_Failure {
  ID_NOT_EXIST = 0,
  OFFLINE = 2,
  LICENSE_MISMATCH = 3,
  LICENSE_OVERUSE = 4,
  UNRECOGNIZED = -1,
}

export function punchHoleResponse_FailureFromJSON(object: any): PunchHoleResponse_Failure {
  switch (object) {
    case 0:
    case "ID_NOT_EXIST":
      return PunchHoleResponse_Failure.ID_NOT_EXIST;
    case 2:
    case "OFFLINE":
      return PunchHoleResponse_Failure.OFFLINE;
    case 3:
    case "LICENSE_MISMATCH":
      return PunchHoleResponse_Failure.LICENSE_MISMATCH;
    case 4:
    case "LICENSE_OVERUSE":
      return PunchHoleResponse_Failure.LICENSE_OVERUSE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PunchHoleResponse_Failure.UNRECOGNIZED;
  }
}

export function punchHoleResponse_FailureToJSON(object: PunchHoleResponse_Failure): string {
  switch (object) {
    case PunchHoleResponse_Failure.ID_NOT_EXIST:
      return "ID_NOT_EXIST";
    case PunchHoleResponse_Failure.OFFLINE:
      return "OFFLINE";
    case PunchHoleResponse_Failure.LICENSE_MISMATCH:
      return "LICENSE_MISMATCH";
    case PunchHoleResponse_Failure.LICENSE_OVERUSE:
      return "LICENSE_OVERUSE";
    case PunchHoleResponse_Failure.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ConfigUpdate {
  serial: number;
  rendezvous_servers: string[];
}

export interface RequestRelay {
  id: string;
  uuid: string;
  socket_addr: Uint8Array;
  relay_server: string;
  secure: boolean;
  licence_key: string;
  conn_type: ConnType;
  token: string;
  control_permissions: ControlPermissions | undefined;
  controlled_context: ControlledContext | undefined;
  switch_code: string;
}

export interface RelayResponse {
  socket_addr: Uint8Array;
  uuid: string;
  relay_server: string;
  id?: string | undefined;
  pk?: Uint8Array | undefined;
  refuse_reason: string;
  version: string;
  feedback: number;
  socket_addr_v6: Uint8Array;
  upnp_port: number;
}

export interface SoftwareUpdate {
  url: string;
}

/**
 * if in same intranet, punch hole won't work both for udp and tcp,
 * even some router has below connection error if we connect itself,
 *  { kind: Other, error: "could not resolve to any address" },
 * so we request local address to connect.
 */
export interface FetchLocalAddr {
  socket_addr: Uint8Array;
  relay_server: string;
  socket_addr_v6: Uint8Array;
  control_permissions: ControlPermissions | undefined;
  controlled_context: ControlledContext | undefined;
}

export interface LocalAddr {
  socket_addr: Uint8Array;
  local_addr: Uint8Array;
  relay_server: string;
  id: string;
  version: string;
  socket_addr_v6: Uint8Array;
}

export interface PeerDiscovery {
  cmd: string;
  mac: string;
  id: string;
  username: string;
  hostname: string;
  platform: string;
  misc: string;
}

export interface OnlineRequest {
  id: string;
  peers: string[];
}

export interface OnlineResponse {
  states: Uint8Array;
}

export interface KeyExchange {
  keys: Uint8Array[];
}

export interface HealthCheck {
  token: string;
}

export interface HeaderEntry {
  name: string;
  value: string;
}

export interface HttpProxyRequest {
  method: string;
  path: string;
  headers: HeaderEntry[];
  body: Uint8Array;
}

export interface HttpProxyResponse {
  status: number;
  headers: HeaderEntry[];
  body: Uint8Array;
  error: string;
}

export interface RendezvousMessage {
  register_peer?: RegisterPeer | undefined;
  register_peer_response?: RegisterPeerResponse | undefined;
  punch_hole_request?: PunchHoleRequest | undefined;
  punch_hole?: PunchHole | undefined;
  punch_hole_sent?: PunchHoleSent | undefined;
  punch_hole_response?: PunchHoleResponse | undefined;
  fetch_local_addr?: FetchLocalAddr | undefined;
  local_addr?: LocalAddr | undefined;
  configure_update?: ConfigUpdate | undefined;
  register_pk?: RegisterPk | undefined;
  register_pk_response?: RegisterPkResponse | undefined;
  software_update?: SoftwareUpdate | undefined;
  request_relay?: RequestRelay | undefined;
  relay_response?: RelayResponse | undefined;
  test_nat_request?: TestNatRequest | undefined;
  test_nat_response?: TestNatResponse | undefined;
  peer_discovery?: PeerDiscovery | undefined;
  online_request?: OnlineRequest | undefined;
  online_response?: OnlineResponse | undefined;
  key_exchange?: KeyExchange | undefined;
  hc?: HealthCheck | undefined;
  http_proxy_request?: HttpProxyRequest | undefined;
  http_proxy_response?: HttpProxyResponse | undefined;
}

function createBaseRegisterPeer(): RegisterPeer {
  return { id: "", serial: 0 };
}

export const RegisterPeer = {
  encode(message: RegisterPeer, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.serial !== 0) {
      writer.uint32(16).int32(message.serial);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RegisterPeer {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterPeer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.serial = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegisterPeer {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      serial: isSet(object.serial) ? globalThis.Number(object.serial) : 0,
    };
  },

  toJSON(message: RegisterPeer): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.serial !== 0) {
      obj.serial = Math.round(message.serial);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterPeer>, I>>(base?: I): RegisterPeer {
    return RegisterPeer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterPeer>, I>>(object: I): RegisterPeer {
    const message = createBaseRegisterPeer();
    message.id = object.id ?? "";
    message.serial = object.serial ?? 0;
    return message;
  },
};

function createBaseRegisterPeerResponse(): RegisterPeerResponse {
  return { request_pk: false };
}

export const RegisterPeerResponse = {
  encode(message: RegisterPeerResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.request_pk !== false) {
      writer.uint32(16).bool(message.request_pk);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RegisterPeerResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterPeerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 16) {
            break;
          }

          message.request_pk = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegisterPeerResponse {
    return { request_pk: isSet(object.request_pk) ? globalThis.Boolean(object.request_pk) : false };
  },

  toJSON(message: RegisterPeerResponse): unknown {
    const obj: any = {};
    if (message.request_pk !== false) {
      obj.request_pk = message.request_pk;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterPeerResponse>, I>>(base?: I): RegisterPeerResponse {
    return RegisterPeerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterPeerResponse>, I>>(object: I): RegisterPeerResponse {
    const message = createBaseRegisterPeerResponse();
    message.request_pk = object.request_pk ?? false;
    return message;
  },
};

function createBasePunchHoleRequest(): PunchHoleRequest {
  return {
    id: "",
    nat_type: 0,
    licence_key: "",
    conn_type: 0,
    token: "",
    version: "",
    udp_port: 0,
    force_relay: false,
    upnp_port: 0,
    socket_addr_v6: new Uint8Array(0),
    switch_code: "",
  };
}

export const PunchHoleRequest = {
  encode(message: PunchHoleRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.nat_type !== 0) {
      writer.uint32(16).int32(message.nat_type);
    }
    if (message.licence_key !== "") {
      writer.uint32(26).string(message.licence_key);
    }
    if (message.conn_type !== 0) {
      writer.uint32(32).int32(message.conn_type);
    }
    if (message.token !== "") {
      writer.uint32(42).string(message.token);
    }
    if (message.version !== "") {
      writer.uint32(50).string(message.version);
    }
    if (message.udp_port !== 0) {
      writer.uint32(56).int32(message.udp_port);
    }
    if (message.force_relay !== false) {
      writer.uint32(64).bool(message.force_relay);
    }
    if (message.upnp_port !== 0) {
      writer.uint32(72).int32(message.upnp_port);
    }
    if (message.socket_addr_v6.length !== 0) {
      writer.uint32(82).bytes(message.socket_addr_v6);
    }
    if (message.switch_code !== "") {
      writer.uint32(90).string(message.switch_code);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PunchHoleRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePunchHoleRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.nat_type = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.licence_key = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.conn_type = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.token = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.version = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.udp_port = reader.int32();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.force_relay = reader.bool();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.upnp_port = reader.int32();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.socket_addr_v6 = reader.bytes();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.switch_code = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PunchHoleRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      nat_type: isSet(object.nat_type) ? natTypeFromJSON(object.nat_type) : 0,
      licence_key: isSet(object.licence_key) ? globalThis.String(object.licence_key) : "",
      conn_type: isSet(object.conn_type) ? connTypeFromJSON(object.conn_type) : 0,
      token: isSet(object.token) ? globalThis.String(object.token) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      udp_port: isSet(object.udp_port) ? globalThis.Number(object.udp_port) : 0,
      force_relay: isSet(object.force_relay) ? globalThis.Boolean(object.force_relay) : false,
      upnp_port: isSet(object.upnp_port) ? globalThis.Number(object.upnp_port) : 0,
      socket_addr_v6: isSet(object.socket_addr_v6) ? bytesFromBase64(object.socket_addr_v6) : new Uint8Array(0),
      switch_code: isSet(object.switch_code) ? globalThis.String(object.switch_code) : "",
    };
  },

  toJSON(message: PunchHoleRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.nat_type !== 0) {
      obj.nat_type = natTypeToJSON(message.nat_type);
    }
    if (message.licence_key !== "") {
      obj.licence_key = message.licence_key;
    }
    if (message.conn_type !== 0) {
      obj.conn_type = connTypeToJSON(message.conn_type);
    }
    if (message.token !== "") {
      obj.token = message.token;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.udp_port !== 0) {
      obj.udp_port = Math.round(message.udp_port);
    }
    if (message.force_relay !== false) {
      obj.force_relay = message.force_relay;
    }
    if (message.upnp_port !== 0) {
      obj.upnp_port = Math.round(message.upnp_port);
    }
    if (message.socket_addr_v6.length !== 0) {
      obj.socket_addr_v6 = base64FromBytes(message.socket_addr_v6);
    }
    if (message.switch_code !== "") {
      obj.switch_code = message.switch_code;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PunchHoleRequest>, I>>(base?: I): PunchHoleRequest {
    return PunchHoleRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PunchHoleRequest>, I>>(object: I): PunchHoleRequest {
    const message = createBasePunchHoleRequest();
    message.id = object.id ?? "";
    message.nat_type = object.nat_type ?? 0;
    message.licence_key = object.licence_key ?? "";
    message.conn_type = object.conn_type ?? 0;
    message.token = object.token ?? "";
    message.version = object.version ?? "";
    message.udp_port = object.udp_port ?? 0;
    message.force_relay = object.force_relay ?? false;
    message.upnp_port = object.upnp_port ?? 0;
    message.socket_addr_v6 = object.socket_addr_v6 ?? new Uint8Array(0);
    message.switch_code = object.switch_code ?? "";
    return message;
  },
};

function createBaseControlPermissions(): ControlPermissions {
  return { permissions: 0 };
}

export const ControlPermissions = {
  encode(message: ControlPermissions, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.permissions !== 0) {
      writer.uint32(8).uint64(message.permissions);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ControlPermissions {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseControlPermissions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.permissions = longToNumber(reader.uint64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ControlPermissions {
    return { permissions: isSet(object.permissions) ? globalThis.Number(object.permissions) : 0 };
  },

  toJSON(message: ControlPermissions): unknown {
    const obj: any = {};
    if (message.permissions !== 0) {
      obj.permissions = Math.round(message.permissions);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ControlPermissions>, I>>(base?: I): ControlPermissions {
    return ControlPermissions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ControlPermissions>, I>>(object: I): ControlPermissions {
    const message = createBaseControlPermissions();
    message.permissions = object.permissions ?? 0;
    return message;
  },
};

function createBaseControlledContext(): ControlledContext {
  return { conn_audit_ref: "" };
}

export const ControlledContext = {
  encode(message: ControlledContext, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.conn_audit_ref !== "") {
      writer.uint32(10).string(message.conn_audit_ref);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ControlledContext {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseControlledContext();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.conn_audit_ref = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ControlledContext {
    return { conn_audit_ref: isSet(object.conn_audit_ref) ? globalThis.String(object.conn_audit_ref) : "" };
  },

  toJSON(message: ControlledContext): unknown {
    const obj: any = {};
    if (message.conn_audit_ref !== "") {
      obj.conn_audit_ref = message.conn_audit_ref;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ControlledContext>, I>>(base?: I): ControlledContext {
    return ControlledContext.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ControlledContext>, I>>(object: I): ControlledContext {
    const message = createBaseControlledContext();
    message.conn_audit_ref = object.conn_audit_ref ?? "";
    return message;
  },
};

function createBasePunchHole(): PunchHole {
  return {
    socket_addr: new Uint8Array(0),
    relay_server: "",
    nat_type: 0,
    udp_port: 0,
    force_relay: false,
    upnp_port: 0,
    socket_addr_v6: new Uint8Array(0),
    control_permissions: undefined,
    controlled_context: undefined,
  };
}

export const PunchHole = {
  encode(message: PunchHole, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.socket_addr.length !== 0) {
      writer.uint32(10).bytes(message.socket_addr);
    }
    if (message.relay_server !== "") {
      writer.uint32(18).string(message.relay_server);
    }
    if (message.nat_type !== 0) {
      writer.uint32(24).int32(message.nat_type);
    }
    if (message.udp_port !== 0) {
      writer.uint32(32).int32(message.udp_port);
    }
    if (message.force_relay !== false) {
      writer.uint32(40).bool(message.force_relay);
    }
    if (message.upnp_port !== 0) {
      writer.uint32(48).int32(message.upnp_port);
    }
    if (message.socket_addr_v6.length !== 0) {
      writer.uint32(58).bytes(message.socket_addr_v6);
    }
    if (message.control_permissions !== undefined) {
      ControlPermissions.encode(message.control_permissions, writer.uint32(66).fork()).ldelim();
    }
    if (message.controlled_context !== undefined) {
      ControlledContext.encode(message.controlled_context, writer.uint32(74).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PunchHole {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePunchHole();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.socket_addr = reader.bytes();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.relay_server = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.nat_type = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.udp_port = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.force_relay = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.upnp_port = reader.int32();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.socket_addr_v6 = reader.bytes();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.control_permissions = ControlPermissions.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.controlled_context = ControlledContext.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PunchHole {
    return {
      socket_addr: isSet(object.socket_addr) ? bytesFromBase64(object.socket_addr) : new Uint8Array(0),
      relay_server: isSet(object.relay_server) ? globalThis.String(object.relay_server) : "",
      nat_type: isSet(object.nat_type) ? natTypeFromJSON(object.nat_type) : 0,
      udp_port: isSet(object.udp_port) ? globalThis.Number(object.udp_port) : 0,
      force_relay: isSet(object.force_relay) ? globalThis.Boolean(object.force_relay) : false,
      upnp_port: isSet(object.upnp_port) ? globalThis.Number(object.upnp_port) : 0,
      socket_addr_v6: isSet(object.socket_addr_v6) ? bytesFromBase64(object.socket_addr_v6) : new Uint8Array(0),
      control_permissions: isSet(object.control_permissions)
        ? ControlPermissions.fromJSON(object.control_permissions)
        : undefined,
      controlled_context: isSet(object.controlled_context)
        ? ControlledContext.fromJSON(object.controlled_context)
        : undefined,
    };
  },

  toJSON(message: PunchHole): unknown {
    const obj: any = {};
    if (message.socket_addr.length !== 0) {
      obj.socket_addr = base64FromBytes(message.socket_addr);
    }
    if (message.relay_server !== "") {
      obj.relay_server = message.relay_server;
    }
    if (message.nat_type !== 0) {
      obj.nat_type = natTypeToJSON(message.nat_type);
    }
    if (message.udp_port !== 0) {
      obj.udp_port = Math.round(message.udp_port);
    }
    if (message.force_relay !== false) {
      obj.force_relay = message.force_relay;
    }
    if (message.upnp_port !== 0) {
      obj.upnp_port = Math.round(message.upnp_port);
    }
    if (message.socket_addr_v6.length !== 0) {
      obj.socket_addr_v6 = base64FromBytes(message.socket_addr_v6);
    }
    if (message.control_permissions !== undefined) {
      obj.control_permissions = ControlPermissions.toJSON(message.control_permissions);
    }
    if (message.controlled_context !== undefined) {
      obj.controlled_context = ControlledContext.toJSON(message.controlled_context);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PunchHole>, I>>(base?: I): PunchHole {
    return PunchHole.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PunchHole>, I>>(object: I): PunchHole {
    const message = createBasePunchHole();
    message.socket_addr = object.socket_addr ?? new Uint8Array(0);
    message.relay_server = object.relay_server ?? "";
    message.nat_type = object.nat_type ?? 0;
    message.udp_port = object.udp_port ?? 0;
    message.force_relay = object.force_relay ?? false;
    message.upnp_port = object.upnp_port ?? 0;
    message.socket_addr_v6 = object.socket_addr_v6 ?? new Uint8Array(0);
    message.control_permissions = (object.control_permissions !== undefined && object.control_permissions !== null)
      ? ControlPermissions.fromPartial(object.control_permissions)
      : undefined;
    message.controlled_context = (object.controlled_context !== undefined && object.controlled_context !== null)
      ? ControlledContext.fromPartial(object.controlled_context)
      : undefined;
    return message;
  },
};

function createBaseTestNatRequest(): TestNatRequest {
  return { serial: 0 };
}

export const TestNatRequest = {
  encode(message: TestNatRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.serial !== 0) {
      writer.uint32(8).int32(message.serial);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TestNatRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestNatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.serial = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TestNatRequest {
    return { serial: isSet(object.serial) ? globalThis.Number(object.serial) : 0 };
  },

  toJSON(message: TestNatRequest): unknown {
    const obj: any = {};
    if (message.serial !== 0) {
      obj.serial = Math.round(message.serial);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TestNatRequest>, I>>(base?: I): TestNatRequest {
    return TestNatRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestNatRequest>, I>>(object: I): TestNatRequest {
    const message = createBaseTestNatRequest();
    message.serial = object.serial ?? 0;
    return message;
  },
};

function createBaseTestNatResponse(): TestNatResponse {
  return { port: 0, cu: undefined };
}

export const TestNatResponse = {
  encode(message: TestNatResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.port !== 0) {
      writer.uint32(8).int32(message.port);
    }
    if (message.cu !== undefined) {
      ConfigUpdate.encode(message.cu, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TestNatResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestNatResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.port = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.cu = ConfigUpdate.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TestNatResponse {
    return {
      port: isSet(object.port) ? globalThis.Number(object.port) : 0,
      cu: isSet(object.cu) ? ConfigUpdate.fromJSON(object.cu) : undefined,
    };
  },

  toJSON(message: TestNatResponse): unknown {
    const obj: any = {};
    if (message.port !== 0) {
      obj.port = Math.round(message.port);
    }
    if (message.cu !== undefined) {
      obj.cu = ConfigUpdate.toJSON(message.cu);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TestNatResponse>, I>>(base?: I): TestNatResponse {
    return TestNatResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestNatResponse>, I>>(object: I): TestNatResponse {
    const message = createBaseTestNatResponse();
    message.port = object.port ?? 0;
    message.cu = (object.cu !== undefined && object.cu !== null) ? ConfigUpdate.fromPartial(object.cu) : undefined;
    return message;
  },
};

function createBasePunchHoleSent(): PunchHoleSent {
  return {
    socket_addr: new Uint8Array(0),
    id: "",
    relay_server: "",
    nat_type: 0,
    version: "",
    upnp_port: 0,
    socket_addr_v6: new Uint8Array(0),
  };
}

export const PunchHoleSent = {
  encode(message: PunchHoleSent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.socket_addr.length !== 0) {
      writer.uint32(10).bytes(message.socket_addr);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.relay_server !== "") {
      writer.uint32(26).string(message.relay_server);
    }
    if (message.nat_type !== 0) {
      writer.uint32(32).int32(message.nat_type);
    }
    if (message.version !== "") {
      writer.uint32(42).string(message.version);
    }
    if (message.upnp_port !== 0) {
      writer.uint32(48).int32(message.upnp_port);
    }
    if (message.socket_addr_v6.length !== 0) {
      writer.uint32(58).bytes(message.socket_addr_v6);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PunchHoleSent {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePunchHoleSent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.socket_addr = reader.bytes();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.relay_server = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.nat_type = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.version = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.upnp_port = reader.int32();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.socket_addr_v6 = reader.bytes();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PunchHoleSent {
    return {
      socket_addr: isSet(object.socket_addr) ? bytesFromBase64(object.socket_addr) : new Uint8Array(0),
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      relay_server: isSet(object.relay_server) ? globalThis.String(object.relay_server) : "",
      nat_type: isSet(object.nat_type) ? natTypeFromJSON(object.nat_type) : 0,
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      upnp_port: isSet(object.upnp_port) ? globalThis.Number(object.upnp_port) : 0,
      socket_addr_v6: isSet(object.socket_addr_v6) ? bytesFromBase64(object.socket_addr_v6) : new Uint8Array(0),
    };
  },

  toJSON(message: PunchHoleSent): unknown {
    const obj: any = {};
    if (message.socket_addr.length !== 0) {
      obj.socket_addr = base64FromBytes(message.socket_addr);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.relay_server !== "") {
      obj.relay_server = message.relay_server;
    }
    if (message.nat_type !== 0) {
      obj.nat_type = natTypeToJSON(message.nat_type);
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.upnp_port !== 0) {
      obj.upnp_port = Math.round(message.upnp_port);
    }
    if (message.socket_addr_v6.length !== 0) {
      obj.socket_addr_v6 = base64FromBytes(message.socket_addr_v6);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PunchHoleSent>, I>>(base?: I): PunchHoleSent {
    return PunchHoleSent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PunchHoleSent>, I>>(object: I): PunchHoleSent {
    const message = createBasePunchHoleSent();
    message.socket_addr = object.socket_addr ?? new Uint8Array(0);
    message.id = object.id ?? "";
    message.relay_server = object.relay_server ?? "";
    message.nat_type = object.nat_type ?? 0;
    message.version = object.version ?? "";
    message.upnp_port = object.upnp_port ?? 0;
    message.socket_addr_v6 = object.socket_addr_v6 ?? new Uint8Array(0);
    return message;
  },
};

function createBaseRegisterPk(): RegisterPk {
  return { id: "", uuid: new Uint8Array(0), pk: new Uint8Array(0), old_id: "", no_register_device: false };
}

export const RegisterPk = {
  encode(message: RegisterPk, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.uuid.length !== 0) {
      writer.uint32(18).bytes(message.uuid);
    }
    if (message.pk.length !== 0) {
      writer.uint32(26).bytes(message.pk);
    }
    if (message.old_id !== "") {
      writer.uint32(34).string(message.old_id);
    }
    if (message.no_register_device !== false) {
      writer.uint32(40).bool(message.no_register_device);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RegisterPk {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterPk();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.uuid = reader.bytes();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.pk = reader.bytes();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.old_id = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.no_register_device = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegisterPk {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      uuid: isSet(object.uuid) ? bytesFromBase64(object.uuid) : new Uint8Array(0),
      pk: isSet(object.pk) ? bytesFromBase64(object.pk) : new Uint8Array(0),
      old_id: isSet(object.old_id) ? globalThis.String(object.old_id) : "",
      no_register_device: isSet(object.no_register_device) ? globalThis.Boolean(object.no_register_device) : false,
    };
  },

  toJSON(message: RegisterPk): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.uuid.length !== 0) {
      obj.uuid = base64FromBytes(message.uuid);
    }
    if (message.pk.length !== 0) {
      obj.pk = base64FromBytes(message.pk);
    }
    if (message.old_id !== "") {
      obj.old_id = message.old_id;
    }
    if (message.no_register_device !== false) {
      obj.no_register_device = message.no_register_device;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterPk>, I>>(base?: I): RegisterPk {
    return RegisterPk.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterPk>, I>>(object: I): RegisterPk {
    const message = createBaseRegisterPk();
    message.id = object.id ?? "";
    message.uuid = object.uuid ?? new Uint8Array(0);
    message.pk = object.pk ?? new Uint8Array(0);
    message.old_id = object.old_id ?? "";
    message.no_register_device = object.no_register_device ?? false;
    return message;
  },
};

function createBaseRegisterPkResponse(): RegisterPkResponse {
  return { result: 0, keep_alive: 0 };
}

export const RegisterPkResponse = {
  encode(message: RegisterPkResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.result !== 0) {
      writer.uint32(8).int32(message.result);
    }
    if (message.keep_alive !== 0) {
      writer.uint32(16).int32(message.keep_alive);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RegisterPkResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterPkResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.result = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.keep_alive = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegisterPkResponse {
    return {
      result: isSet(object.result) ? registerPkResponse_ResultFromJSON(object.result) : 0,
      keep_alive: isSet(object.keep_alive) ? globalThis.Number(object.keep_alive) : 0,
    };
  },

  toJSON(message: RegisterPkResponse): unknown {
    const obj: any = {};
    if (message.result !== 0) {
      obj.result = registerPkResponse_ResultToJSON(message.result);
    }
    if (message.keep_alive !== 0) {
      obj.keep_alive = Math.round(message.keep_alive);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterPkResponse>, I>>(base?: I): RegisterPkResponse {
    return RegisterPkResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterPkResponse>, I>>(object: I): RegisterPkResponse {
    const message = createBaseRegisterPkResponse();
    message.result = object.result ?? 0;
    message.keep_alive = object.keep_alive ?? 0;
    return message;
  },
};

function createBasePunchHoleResponse(): PunchHoleResponse {
  return {
    socket_addr: new Uint8Array(0),
    pk: new Uint8Array(0),
    failure: 0,
    relay_server: "",
    nat_type: undefined,
    is_local: undefined,
    other_failure: "",
    feedback: 0,
    is_udp: false,
    upnp_port: 0,
    socket_addr_v6: new Uint8Array(0),
  };
}

export const PunchHoleResponse = {
  encode(message: PunchHoleResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.socket_addr.length !== 0) {
      writer.uint32(10).bytes(message.socket_addr);
    }
    if (message.pk.length !== 0) {
      writer.uint32(18).bytes(message.pk);
    }
    if (message.failure !== 0) {
      writer.uint32(24).int32(message.failure);
    }
    if (message.relay_server !== "") {
      writer.uint32(34).string(message.relay_server);
    }
    if (message.nat_type !== undefined) {
      writer.uint32(40).int32(message.nat_type);
    }
    if (message.is_local !== undefined) {
      writer.uint32(48).bool(message.is_local);
    }
    if (message.other_failure !== "") {
      writer.uint32(58).string(message.other_failure);
    }
    if (message.feedback !== 0) {
      writer.uint32(64).int32(message.feedback);
    }
    if (message.is_udp !== false) {
      writer.uint32(72).bool(message.is_udp);
    }
    if (message.upnp_port !== 0) {
      writer.uint32(80).int32(message.upnp_port);
    }
    if (message.socket_addr_v6.length !== 0) {
      writer.uint32(90).bytes(message.socket_addr_v6);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PunchHoleResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePunchHoleResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.socket_addr = reader.bytes();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.pk = reader.bytes();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.failure = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.relay_server = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.nat_type = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.is_local = reader.bool();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.other_failure = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.feedback = reader.int32();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.is_udp = reader.bool();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.upnp_port = reader.int32();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.socket_addr_v6 = reader.bytes();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PunchHoleResponse {
    return {
      socket_addr: isSet(object.socket_addr) ? bytesFromBase64(object.socket_addr) : new Uint8Array(0),
      pk: isSet(object.pk) ? bytesFromBase64(object.pk) : new Uint8Array(0),
      failure: isSet(object.failure) ? punchHoleResponse_FailureFromJSON(object.failure) : 0,
      relay_server: isSet(object.relay_server) ? globalThis.String(object.relay_server) : "",
      nat_type: isSet(object.nat_type) ? natTypeFromJSON(object.nat_type) : undefined,
      is_local: isSet(object.is_local) ? globalThis.Boolean(object.is_local) : undefined,
      other_failure: isSet(object.other_failure) ? globalThis.String(object.other_failure) : "",
      feedback: isSet(object.feedback) ? globalThis.Number(object.feedback) : 0,
      is_udp: isSet(object.is_udp) ? globalThis.Boolean(object.is_udp) : false,
      upnp_port: isSet(object.upnp_port) ? globalThis.Number(object.upnp_port) : 0,
      socket_addr_v6: isSet(object.socket_addr_v6) ? bytesFromBase64(object.socket_addr_v6) : new Uint8Array(0),
    };
  },

  toJSON(message: PunchHoleResponse): unknown {
    const obj: any = {};
    if (message.socket_addr.length !== 0) {
      obj.socket_addr = base64FromBytes(message.socket_addr);
    }
    if (message.pk.length !== 0) {
      obj.pk = base64FromBytes(message.pk);
    }
    if (message.failure !== 0) {
      obj.failure = punchHoleResponse_FailureToJSON(message.failure);
    }
    if (message.relay_server !== "") {
      obj.relay_server = message.relay_server;
    }
    if (message.nat_type !== undefined) {
      obj.nat_type = natTypeToJSON(message.nat_type);
    }
    if (message.is_local !== undefined) {
      obj.is_local = message.is_local;
    }
    if (message.other_failure !== "") {
      obj.other_failure = message.other_failure;
    }
    if (message.feedback !== 0) {
      obj.feedback = Math.round(message.feedback);
    }
    if (message.is_udp !== false) {
      obj.is_udp = message.is_udp;
    }
    if (message.upnp_port !== 0) {
      obj.upnp_port = Math.round(message.upnp_port);
    }
    if (message.socket_addr_v6.length !== 0) {
      obj.socket_addr_v6 = base64FromBytes(message.socket_addr_v6);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PunchHoleResponse>, I>>(base?: I): PunchHoleResponse {
    return PunchHoleResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PunchHoleResponse>, I>>(object: I): PunchHoleResponse {
    const message = createBasePunchHoleResponse();
    message.socket_addr = object.socket_addr ?? new Uint8Array(0);
    message.pk = object.pk ?? new Uint8Array(0);
    message.failure = object.failure ?? 0;
    message.relay_server = object.relay_server ?? "";
    message.nat_type = object.nat_type ?? undefined;
    message.is_local = object.is_local ?? undefined;
    message.other_failure = object.other_failure ?? "";
    message.feedback = object.feedback ?? 0;
    message.is_udp = object.is_udp ?? false;
    message.upnp_port = object.upnp_port ?? 0;
    message.socket_addr_v6 = object.socket_addr_v6 ?? new Uint8Array(0);
    return message;
  },
};

function createBaseConfigUpdate(): ConfigUpdate {
  return { serial: 0, rendezvous_servers: [] };
}

export const ConfigUpdate = {
  encode(message: ConfigUpdate, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.serial !== 0) {
      writer.uint32(8).int32(message.serial);
    }
    for (const v of message.rendezvous_servers) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ConfigUpdate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.serial = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.rendezvous_servers.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfigUpdate {
    return {
      serial: isSet(object.serial) ? globalThis.Number(object.serial) : 0,
      rendezvous_servers: globalThis.Array.isArray(object?.rendezvous_servers)
        ? object.rendezvous_servers.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ConfigUpdate): unknown {
    const obj: any = {};
    if (message.serial !== 0) {
      obj.serial = Math.round(message.serial);
    }
    if (message.rendezvous_servers?.length) {
      obj.rendezvous_servers = message.rendezvous_servers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConfigUpdate>, I>>(base?: I): ConfigUpdate {
    return ConfigUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfigUpdate>, I>>(object: I): ConfigUpdate {
    const message = createBaseConfigUpdate();
    message.serial = object.serial ?? 0;
    message.rendezvous_servers = object.rendezvous_servers?.map((e) => e) || [];
    return message;
  },
};

function createBaseRequestRelay(): RequestRelay {
  return {
    id: "",
    uuid: "",
    socket_addr: new Uint8Array(0),
    relay_server: "",
    secure: false,
    licence_key: "",
    conn_type: 0,
    token: "",
    control_permissions: undefined,
    controlled_context: undefined,
    switch_code: "",
  };
}

export const RequestRelay = {
  encode(message: RequestRelay, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.uuid !== "") {
      writer.uint32(18).string(message.uuid);
    }
    if (message.socket_addr.length !== 0) {
      writer.uint32(26).bytes(message.socket_addr);
    }
    if (message.relay_server !== "") {
      writer.uint32(34).string(message.relay_server);
    }
    if (message.secure !== false) {
      writer.uint32(40).bool(message.secure);
    }
    if (message.licence_key !== "") {
      writer.uint32(50).string(message.licence_key);
    }
    if (message.conn_type !== 0) {
      writer.uint32(56).int32(message.conn_type);
    }
    if (message.token !== "") {
      writer.uint32(66).string(message.token);
    }
    if (message.control_permissions !== undefined) {
      ControlPermissions.encode(message.control_permissions, writer.uint32(74).fork()).ldelim();
    }
    if (message.controlled_context !== undefined) {
      ControlledContext.encode(message.controlled_context, writer.uint32(82).fork()).ldelim();
    }
    if (message.switch_code !== "") {
      writer.uint32(90).string(message.switch_code);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RequestRelay {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestRelay();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.uuid = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.socket_addr = reader.bytes();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.relay_server = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.secure = reader.bool();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.licence_key = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.conn_type = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.token = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.control_permissions = ControlPermissions.decode(reader, reader.uint32());
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.controlled_context = ControlledContext.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.switch_code = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestRelay {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      socket_addr: isSet(object.socket_addr) ? bytesFromBase64(object.socket_addr) : new Uint8Array(0),
      relay_server: isSet(object.relay_server) ? globalThis.String(object.relay_server) : "",
      secure: isSet(object.secure) ? globalThis.Boolean(object.secure) : false,
      licence_key: isSet(object.licence_key) ? globalThis.String(object.licence_key) : "",
      conn_type: isSet(object.conn_type) ? connTypeFromJSON(object.conn_type) : 0,
      token: isSet(object.token) ? globalThis.String(object.token) : "",
      control_permissions: isSet(object.control_permissions)
        ? ControlPermissions.fromJSON(object.control_permissions)
        : undefined,
      controlled_context: isSet(object.controlled_context)
        ? ControlledContext.fromJSON(object.controlled_context)
        : undefined,
      switch_code: isSet(object.switch_code) ? globalThis.String(object.switch_code) : "",
    };
  },

  toJSON(message: RequestRelay): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.socket_addr.length !== 0) {
      obj.socket_addr = base64FromBytes(message.socket_addr);
    }
    if (message.relay_server !== "") {
      obj.relay_server = message.relay_server;
    }
    if (message.secure !== false) {
      obj.secure = message.secure;
    }
    if (message.licence_key !== "") {
      obj.licence_key = message.licence_key;
    }
    if (message.conn_type !== 0) {
      obj.conn_type = connTypeToJSON(message.conn_type);
    }
    if (message.token !== "") {
      obj.token = message.token;
    }
    if (message.control_permissions !== undefined) {
      obj.control_permissions = ControlPermissions.toJSON(message.control_permissions);
    }
    if (message.controlled_context !== undefined) {
      obj.controlled_context = ControlledContext.toJSON(message.controlled_context);
    }
    if (message.switch_code !== "") {
      obj.switch_code = message.switch_code;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestRelay>, I>>(base?: I): RequestRelay {
    return RequestRelay.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestRelay>, I>>(object: I): RequestRelay {
    const message = createBaseRequestRelay();
    message.id = object.id ?? "";
    message.uuid = object.uuid ?? "";
    message.socket_addr = object.socket_addr ?? new Uint8Array(0);
    message.relay_server = object.relay_server ?? "";
    message.secure = object.secure ?? false;
    message.licence_key = object.licence_key ?? "";
    message.conn_type = object.conn_type ?? 0;
    message.token = object.token ?? "";
    message.control_permissions = (object.control_permissions !== undefined && object.control_permissions !== null)
      ? ControlPermissions.fromPartial(object.control_permissions)
      : undefined;
    message.controlled_context = (object.controlled_context !== undefined && object.controlled_context !== null)
      ? ControlledContext.fromPartial(object.controlled_context)
      : undefined;
    message.switch_code = object.switch_code ?? "";
    return message;
  },
};

function createBaseRelayResponse(): RelayResponse {
  return {
    socket_addr: new Uint8Array(0),
    uuid: "",
    relay_server: "",
    id: undefined,
    pk: undefined,
    refuse_reason: "",
    version: "",
    feedback: 0,
    socket_addr_v6: new Uint8Array(0),
    upnp_port: 0,
  };
}

export const RelayResponse = {
  encode(message: RelayResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.socket_addr.length !== 0) {
      writer.uint32(10).bytes(message.socket_addr);
    }
    if (message.uuid !== "") {
      writer.uint32(18).string(message.uuid);
    }
    if (message.relay_server !== "") {
      writer.uint32(26).string(message.relay_server);
    }
    if (message.id !== undefined) {
      writer.uint32(34).string(message.id);
    }
    if (message.pk !== undefined) {
      writer.uint32(42).bytes(message.pk);
    }
    if (message.refuse_reason !== "") {
      writer.uint32(50).string(message.refuse_reason);
    }
    if (message.version !== "") {
      writer.uint32(58).string(message.version);
    }
    if (message.feedback !== 0) {
      writer.uint32(72).int32(message.feedback);
    }
    if (message.socket_addr_v6.length !== 0) {
      writer.uint32(82).bytes(message.socket_addr_v6);
    }
    if (message.upnp_port !== 0) {
      writer.uint32(88).int32(message.upnp_port);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RelayResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRelayResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.socket_addr = reader.bytes();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.uuid = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.relay_server = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.id = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.pk = reader.bytes();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.refuse_reason = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.version = reader.string();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.feedback = reader.int32();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.socket_addr_v6 = reader.bytes();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.upnp_port = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RelayResponse {
    return {
      socket_addr: isSet(object.socket_addr) ? bytesFromBase64(object.socket_addr) : new Uint8Array(0),
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      relay_server: isSet(object.relay_server) ? globalThis.String(object.relay_server) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      pk: isSet(object.pk) ? bytesFromBase64(object.pk) : undefined,
      refuse_reason: isSet(object.refuse_reason) ? globalThis.String(object.refuse_reason) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      feedback: isSet(object.feedback) ? globalThis.Number(object.feedback) : 0,
      socket_addr_v6: isSet(object.socket_addr_v6) ? bytesFromBase64(object.socket_addr_v6) : new Uint8Array(0),
      upnp_port: isSet(object.upnp_port) ? globalThis.Number(object.upnp_port) : 0,
    };
  },

  toJSON(message: RelayResponse): unknown {
    const obj: any = {};
    if (message.socket_addr.length !== 0) {
      obj.socket_addr = base64FromBytes(message.socket_addr);
    }
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.relay_server !== "") {
      obj.relay_server = message.relay_server;
    }
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.pk !== undefined) {
      obj.pk = base64FromBytes(message.pk);
    }
    if (message.refuse_reason !== "") {
      obj.refuse_reason = message.refuse_reason;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.feedback !== 0) {
      obj.feedback = Math.round(message.feedback);
    }
    if (message.socket_addr_v6.length !== 0) {
      obj.socket_addr_v6 = base64FromBytes(message.socket_addr_v6);
    }
    if (message.upnp_port !== 0) {
      obj.upnp_port = Math.round(message.upnp_port);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RelayResponse>, I>>(base?: I): RelayResponse {
    return RelayResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RelayResponse>, I>>(object: I): RelayResponse {
    const message = createBaseRelayResponse();
    message.socket_addr = object.socket_addr ?? new Uint8Array(0);
    message.uuid = object.uuid ?? "";
    message.relay_server = object.relay_server ?? "";
    message.id = object.id ?? undefined;
    message.pk = object.pk ?? undefined;
    message.refuse_reason = object.refuse_reason ?? "";
    message.version = object.version ?? "";
    message.feedback = object.feedback ?? 0;
    message.socket_addr_v6 = object.socket_addr_v6 ?? new Uint8Array(0);
    message.upnp_port = object.upnp_port ?? 0;
    return message;
  },
};

function createBaseSoftwareUpdate(): SoftwareUpdate {
  return { url: "" };
}

export const SoftwareUpdate = {
  encode(message: SoftwareUpdate, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SoftwareUpdate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSoftwareUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SoftwareUpdate {
    return { url: isSet(object.url) ? globalThis.String(object.url) : "" };
  },

  toJSON(message: SoftwareUpdate): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SoftwareUpdate>, I>>(base?: I): SoftwareUpdate {
    return SoftwareUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SoftwareUpdate>, I>>(object: I): SoftwareUpdate {
    const message = createBaseSoftwareUpdate();
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseFetchLocalAddr(): FetchLocalAddr {
  return {
    socket_addr: new Uint8Array(0),
    relay_server: "",
    socket_addr_v6: new Uint8Array(0),
    control_permissions: undefined,
    controlled_context: undefined,
  };
}

export const FetchLocalAddr = {
  encode(message: FetchLocalAddr, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.socket_addr.length !== 0) {
      writer.uint32(10).bytes(message.socket_addr);
    }
    if (message.relay_server !== "") {
      writer.uint32(18).string(message.relay_server);
    }
    if (message.socket_addr_v6.length !== 0) {
      writer.uint32(26).bytes(message.socket_addr_v6);
    }
    if (message.control_permissions !== undefined) {
      ControlPermissions.encode(message.control_permissions, writer.uint32(34).fork()).ldelim();
    }
    if (message.controlled_context !== undefined) {
      ControlledContext.encode(message.controlled_context, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FetchLocalAddr {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFetchLocalAddr();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.socket_addr = reader.bytes();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.relay_server = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.socket_addr_v6 = reader.bytes();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.control_permissions = ControlPermissions.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.controlled_context = ControlledContext.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FetchLocalAddr {
    return {
      socket_addr: isSet(object.socket_addr) ? bytesFromBase64(object.socket_addr) : new Uint8Array(0),
      relay_server: isSet(object.relay_server) ? globalThis.String(object.relay_server) : "",
      socket_addr_v6: isSet(object.socket_addr_v6) ? bytesFromBase64(object.socket_addr_v6) : new Uint8Array(0),
      control_permissions: isSet(object.control_permissions)
        ? ControlPermissions.fromJSON(object.control_permissions)
        : undefined,
      controlled_context: isSet(object.controlled_context)
        ? ControlledContext.fromJSON(object.controlled_context)
        : undefined,
    };
  },

  toJSON(message: FetchLocalAddr): unknown {
    const obj: any = {};
    if (message.socket_addr.length !== 0) {
      obj.socket_addr = base64FromBytes(message.socket_addr);
    }
    if (message.relay_server !== "") {
      obj.relay_server = message.relay_server;
    }
    if (message.socket_addr_v6.length !== 0) {
      obj.socket_addr_v6 = base64FromBytes(message.socket_addr_v6);
    }
    if (message.control_permissions !== undefined) {
      obj.control_permissions = ControlPermissions.toJSON(message.control_permissions);
    }
    if (message.controlled_context !== undefined) {
      obj.controlled_context = ControlledContext.toJSON(message.controlled_context);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FetchLocalAddr>, I>>(base?: I): FetchLocalAddr {
    return FetchLocalAddr.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FetchLocalAddr>, I>>(object: I): FetchLocalAddr {
    const message = createBaseFetchLocalAddr();
    message.socket_addr = object.socket_addr ?? new Uint8Array(0);
    message.relay_server = object.relay_server ?? "";
    message.socket_addr_v6 = object.socket_addr_v6 ?? new Uint8Array(0);
    message.control_permissions = (object.control_permissions !== undefined && object.control_permissions !== null)
      ? ControlPermissions.fromPartial(object.control_permissions)
      : undefined;
    message.controlled_context = (object.controlled_context !== undefined && object.controlled_context !== null)
      ? ControlledContext.fromPartial(object.controlled_context)
      : undefined;
    return message;
  },
};

function createBaseLocalAddr(): LocalAddr {
  return {
    socket_addr: new Uint8Array(0),
    local_addr: new Uint8Array(0),
    relay_server: "",
    id: "",
    version: "",
    socket_addr_v6: new Uint8Array(0),
  };
}

export const LocalAddr = {
  encode(message: LocalAddr, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.socket_addr.length !== 0) {
      writer.uint32(10).bytes(message.socket_addr);
    }
    if (message.local_addr.length !== 0) {
      writer.uint32(18).bytes(message.local_addr);
    }
    if (message.relay_server !== "") {
      writer.uint32(26).string(message.relay_server);
    }
    if (message.id !== "") {
      writer.uint32(34).string(message.id);
    }
    if (message.version !== "") {
      writer.uint32(42).string(message.version);
    }
    if (message.socket_addr_v6.length !== 0) {
      writer.uint32(50).bytes(message.socket_addr_v6);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LocalAddr {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocalAddr();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.socket_addr = reader.bytes();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.local_addr = reader.bytes();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.relay_server = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.id = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.version = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.socket_addr_v6 = reader.bytes();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LocalAddr {
    return {
      socket_addr: isSet(object.socket_addr) ? bytesFromBase64(object.socket_addr) : new Uint8Array(0),
      local_addr: isSet(object.local_addr) ? bytesFromBase64(object.local_addr) : new Uint8Array(0),
      relay_server: isSet(object.relay_server) ? globalThis.String(object.relay_server) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      socket_addr_v6: isSet(object.socket_addr_v6) ? bytesFromBase64(object.socket_addr_v6) : new Uint8Array(0),
    };
  },

  toJSON(message: LocalAddr): unknown {
    const obj: any = {};
    if (message.socket_addr.length !== 0) {
      obj.socket_addr = base64FromBytes(message.socket_addr);
    }
    if (message.local_addr.length !== 0) {
      obj.local_addr = base64FromBytes(message.local_addr);
    }
    if (message.relay_server !== "") {
      obj.relay_server = message.relay_server;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.socket_addr_v6.length !== 0) {
      obj.socket_addr_v6 = base64FromBytes(message.socket_addr_v6);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LocalAddr>, I>>(base?: I): LocalAddr {
    return LocalAddr.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocalAddr>, I>>(object: I): LocalAddr {
    const message = createBaseLocalAddr();
    message.socket_addr = object.socket_addr ?? new Uint8Array(0);
    message.local_addr = object.local_addr ?? new Uint8Array(0);
    message.relay_server = object.relay_server ?? "";
    message.id = object.id ?? "";
    message.version = object.version ?? "";
    message.socket_addr_v6 = object.socket_addr_v6 ?? new Uint8Array(0);
    return message;
  },
};

function createBasePeerDiscovery(): PeerDiscovery {
  return { cmd: "", mac: "", id: "", username: "", hostname: "", platform: "", misc: "" };
}

export const PeerDiscovery = {
  encode(message: PeerDiscovery, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.cmd !== "") {
      writer.uint32(10).string(message.cmd);
    }
    if (message.mac !== "") {
      writer.uint32(18).string(message.mac);
    }
    if (message.id !== "") {
      writer.uint32(26).string(message.id);
    }
    if (message.username !== "") {
      writer.uint32(34).string(message.username);
    }
    if (message.hostname !== "") {
      writer.uint32(42).string(message.hostname);
    }
    if (message.platform !== "") {
      writer.uint32(50).string(message.platform);
    }
    if (message.misc !== "") {
      writer.uint32(58).string(message.misc);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PeerDiscovery {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePeerDiscovery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.cmd = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.mac = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.id = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.username = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.hostname = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.platform = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.misc = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PeerDiscovery {
    return {
      cmd: isSet(object.cmd) ? globalThis.String(object.cmd) : "",
      mac: isSet(object.mac) ? globalThis.String(object.mac) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      username: isSet(object.username) ? globalThis.String(object.username) : "",
      hostname: isSet(object.hostname) ? globalThis.String(object.hostname) : "",
      platform: isSet(object.platform) ? globalThis.String(object.platform) : "",
      misc: isSet(object.misc) ? globalThis.String(object.misc) : "",
    };
  },

  toJSON(message: PeerDiscovery): unknown {
    const obj: any = {};
    if (message.cmd !== "") {
      obj.cmd = message.cmd;
    }
    if (message.mac !== "") {
      obj.mac = message.mac;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.username !== "") {
      obj.username = message.username;
    }
    if (message.hostname !== "") {
      obj.hostname = message.hostname;
    }
    if (message.platform !== "") {
      obj.platform = message.platform;
    }
    if (message.misc !== "") {
      obj.misc = message.misc;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PeerDiscovery>, I>>(base?: I): PeerDiscovery {
    return PeerDiscovery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PeerDiscovery>, I>>(object: I): PeerDiscovery {
    const message = createBasePeerDiscovery();
    message.cmd = object.cmd ?? "";
    message.mac = object.mac ?? "";
    message.id = object.id ?? "";
    message.username = object.username ?? "";
    message.hostname = object.hostname ?? "";
    message.platform = object.platform ?? "";
    message.misc = object.misc ?? "";
    return message;
  },
};

function createBaseOnlineRequest(): OnlineRequest {
  return { id: "", peers: [] };
}

export const OnlineRequest = {
  encode(message: OnlineRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    for (const v of message.peers) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OnlineRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOnlineRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.peers.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OnlineRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      peers: globalThis.Array.isArray(object?.peers) ? object.peers.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: OnlineRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.peers?.length) {
      obj.peers = message.peers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OnlineRequest>, I>>(base?: I): OnlineRequest {
    return OnlineRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OnlineRequest>, I>>(object: I): OnlineRequest {
    const message = createBaseOnlineRequest();
    message.id = object.id ?? "";
    message.peers = object.peers?.map((e) => e) || [];
    return message;
  },
};

function createBaseOnlineResponse(): OnlineResponse {
  return { states: new Uint8Array(0) };
}

export const OnlineResponse = {
  encode(message: OnlineResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.states.length !== 0) {
      writer.uint32(10).bytes(message.states);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OnlineResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOnlineResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.states = reader.bytes();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OnlineResponse {
    return { states: isSet(object.states) ? bytesFromBase64(object.states) : new Uint8Array(0) };
  },

  toJSON(message: OnlineResponse): unknown {
    const obj: any = {};
    if (message.states.length !== 0) {
      obj.states = base64FromBytes(message.states);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OnlineResponse>, I>>(base?: I): OnlineResponse {
    return OnlineResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OnlineResponse>, I>>(object: I): OnlineResponse {
    const message = createBaseOnlineResponse();
    message.states = object.states ?? new Uint8Array(0);
    return message;
  },
};

function createBaseKeyExchange(): KeyExchange {
  return { keys: [] };
}

export const KeyExchange = {
  encode(message: KeyExchange, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.keys) {
      writer.uint32(10).bytes(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): KeyExchange {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyExchange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.keys.push(reader.bytes());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeyExchange {
    return { keys: globalThis.Array.isArray(object?.keys) ? object.keys.map((e: any) => bytesFromBase64(e)) : [] };
  },

  toJSON(message: KeyExchange): unknown {
    const obj: any = {};
    if (message.keys?.length) {
      obj.keys = message.keys.map((e) => base64FromBytes(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KeyExchange>, I>>(base?: I): KeyExchange {
    return KeyExchange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeyExchange>, I>>(object: I): KeyExchange {
    const message = createBaseKeyExchange();
    message.keys = object.keys?.map((e) => e) || [];
    return message;
  },
};

function createBaseHealthCheck(): HealthCheck {
  return { token: "" };
}

export const HealthCheck = {
  encode(message: HealthCheck, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HealthCheck {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHealthCheck();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.token = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HealthCheck {
    return { token: isSet(object.token) ? globalThis.String(object.token) : "" };
  },

  toJSON(message: HealthCheck): unknown {
    const obj: any = {};
    if (message.token !== "") {
      obj.token = message.token;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HealthCheck>, I>>(base?: I): HealthCheck {
    return HealthCheck.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HealthCheck>, I>>(object: I): HealthCheck {
    const message = createBaseHealthCheck();
    message.token = object.token ?? "";
    return message;
  },
};

function createBaseHeaderEntry(): HeaderEntry {
  return { name: "", value: "" };
}

export const HeaderEntry = {
  encode(message: HeaderEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HeaderEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeaderEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HeaderEntry {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: HeaderEntry): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HeaderEntry>, I>>(base?: I): HeaderEntry {
    return HeaderEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HeaderEntry>, I>>(object: I): HeaderEntry {
    const message = createBaseHeaderEntry();
    message.name = object.name ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseHttpProxyRequest(): HttpProxyRequest {
  return { method: "", path: "", headers: [], body: new Uint8Array(0) };
}

export const HttpProxyRequest = {
  encode(message: HttpProxyRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.method !== "") {
      writer.uint32(10).string(message.method);
    }
    if (message.path !== "") {
      writer.uint32(18).string(message.path);
    }
    for (const v of message.headers) {
      HeaderEntry.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.body.length !== 0) {
      writer.uint32(34).bytes(message.body);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HttpProxyRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHttpProxyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.method = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.path = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.headers.push(HeaderEntry.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.body = reader.bytes();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HttpProxyRequest {
    return {
      method: isSet(object.method) ? globalThis.String(object.method) : "",
      path: isSet(object.path) ? globalThis.String(object.path) : "",
      headers: globalThis.Array.isArray(object?.headers) ? object.headers.map((e: any) => HeaderEntry.fromJSON(e)) : [],
      body: isSet(object.body) ? bytesFromBase64(object.body) : new Uint8Array(0),
    };
  },

  toJSON(message: HttpProxyRequest): unknown {
    const obj: any = {};
    if (message.method !== "") {
      obj.method = message.method;
    }
    if (message.path !== "") {
      obj.path = message.path;
    }
    if (message.headers?.length) {
      obj.headers = message.headers.map((e) => HeaderEntry.toJSON(e));
    }
    if (message.body.length !== 0) {
      obj.body = base64FromBytes(message.body);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HttpProxyRequest>, I>>(base?: I): HttpProxyRequest {
    return HttpProxyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HttpProxyRequest>, I>>(object: I): HttpProxyRequest {
    const message = createBaseHttpProxyRequest();
    message.method = object.method ?? "";
    message.path = object.path ?? "";
    message.headers = object.headers?.map((e) => HeaderEntry.fromPartial(e)) || [];
    message.body = object.body ?? new Uint8Array(0);
    return message;
  },
};

function createBaseHttpProxyResponse(): HttpProxyResponse {
  return { status: 0, headers: [], body: new Uint8Array(0), error: "" };
}

export const HttpProxyResponse = {
  encode(message: HttpProxyResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    for (const v of message.headers) {
      HeaderEntry.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.body.length !== 0) {
      writer.uint32(26).bytes(message.body);
    }
    if (message.error !== "") {
      writer.uint32(34).string(message.error);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HttpProxyResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHttpProxyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.headers.push(HeaderEntry.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.body = reader.bytes();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.error = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HttpProxyResponse {
    return {
      status: isSet(object.status) ? globalThis.Number(object.status) : 0,
      headers: globalThis.Array.isArray(object?.headers) ? object.headers.map((e: any) => HeaderEntry.fromJSON(e)) : [],
      body: isSet(object.body) ? bytesFromBase64(object.body) : new Uint8Array(0),
      error: isSet(object.error) ? globalThis.String(object.error) : "",
    };
  },

  toJSON(message: HttpProxyResponse): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = Math.round(message.status);
    }
    if (message.headers?.length) {
      obj.headers = message.headers.map((e) => HeaderEntry.toJSON(e));
    }
    if (message.body.length !== 0) {
      obj.body = base64FromBytes(message.body);
    }
    if (message.error !== "") {
      obj.error = message.error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HttpProxyResponse>, I>>(base?: I): HttpProxyResponse {
    return HttpProxyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HttpProxyResponse>, I>>(object: I): HttpProxyResponse {
    const message = createBaseHttpProxyResponse();
    message.status = object.status ?? 0;
    message.headers = object.headers?.map((e) => HeaderEntry.fromPartial(e)) || [];
    message.body = object.body ?? new Uint8Array(0);
    message.error = object.error ?? "";
    return message;
  },
};

function createBaseRendezvousMessage(): RendezvousMessage {
  return {
    register_peer: undefined,
    register_peer_response: undefined,
    punch_hole_request: undefined,
    punch_hole: undefined,
    punch_hole_sent: undefined,
    punch_hole_response: undefined,
    fetch_local_addr: undefined,
    local_addr: undefined,
    configure_update: undefined,
    register_pk: undefined,
    register_pk_response: undefined,
    software_update: undefined,
    request_relay: undefined,
    relay_response: undefined,
    test_nat_request: undefined,
    test_nat_response: undefined,
    peer_discovery: undefined,
    online_request: undefined,
    online_response: undefined,
    key_exchange: undefined,
    hc: undefined,
    http_proxy_request: undefined,
    http_proxy_response: undefined,
  };
}

export const RendezvousMessage = {
  encode(message: RendezvousMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.register_peer !== undefined) {
      RegisterPeer.encode(message.register_peer, writer.uint32(50).fork()).ldelim();
    }
    if (message.register_peer_response !== undefined) {
      RegisterPeerResponse.encode(message.register_peer_response, writer.uint32(58).fork()).ldelim();
    }
    if (message.punch_hole_request !== undefined) {
      PunchHoleRequest.encode(message.punch_hole_request, writer.uint32(66).fork()).ldelim();
    }
    if (message.punch_hole !== undefined) {
      PunchHole.encode(message.punch_hole, writer.uint32(74).fork()).ldelim();
    }
    if (message.punch_hole_sent !== undefined) {
      PunchHoleSent.encode(message.punch_hole_sent, writer.uint32(82).fork()).ldelim();
    }
    if (message.punch_hole_response !== undefined) {
      PunchHoleResponse.encode(message.punch_hole_response, writer.uint32(90).fork()).ldelim();
    }
    if (message.fetch_local_addr !== undefined) {
      FetchLocalAddr.encode(message.fetch_local_addr, writer.uint32(98).fork()).ldelim();
    }
    if (message.local_addr !== undefined) {
      LocalAddr.encode(message.local_addr, writer.uint32(106).fork()).ldelim();
    }
    if (message.configure_update !== undefined) {
      ConfigUpdate.encode(message.configure_update, writer.uint32(114).fork()).ldelim();
    }
    if (message.register_pk !== undefined) {
      RegisterPk.encode(message.register_pk, writer.uint32(122).fork()).ldelim();
    }
    if (message.register_pk_response !== undefined) {
      RegisterPkResponse.encode(message.register_pk_response, writer.uint32(130).fork()).ldelim();
    }
    if (message.software_update !== undefined) {
      SoftwareUpdate.encode(message.software_update, writer.uint32(138).fork()).ldelim();
    }
    if (message.request_relay !== undefined) {
      RequestRelay.encode(message.request_relay, writer.uint32(146).fork()).ldelim();
    }
    if (message.relay_response !== undefined) {
      RelayResponse.encode(message.relay_response, writer.uint32(154).fork()).ldelim();
    }
    if (message.test_nat_request !== undefined) {
      TestNatRequest.encode(message.test_nat_request, writer.uint32(162).fork()).ldelim();
    }
    if (message.test_nat_response !== undefined) {
      TestNatResponse.encode(message.test_nat_response, writer.uint32(170).fork()).ldelim();
    }
    if (message.peer_discovery !== undefined) {
      PeerDiscovery.encode(message.peer_discovery, writer.uint32(178).fork()).ldelim();
    }
    if (message.online_request !== undefined) {
      OnlineRequest.encode(message.online_request, writer.uint32(186).fork()).ldelim();
    }
    if (message.online_response !== undefined) {
      OnlineResponse.encode(message.online_response, writer.uint32(194).fork()).ldelim();
    }
    if (message.key_exchange !== undefined) {
      KeyExchange.encode(message.key_exchange, writer.uint32(202).fork()).ldelim();
    }
    if (message.hc !== undefined) {
      HealthCheck.encode(message.hc, writer.uint32(210).fork()).ldelim();
    }
    if (message.http_proxy_request !== undefined) {
      HttpProxyRequest.encode(message.http_proxy_request, writer.uint32(218).fork()).ldelim();
    }
    if (message.http_proxy_response !== undefined) {
      HttpProxyResponse.encode(message.http_proxy_response, writer.uint32(226).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RendezvousMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRendezvousMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 6:
          if (tag !== 50) {
            break;
          }

          message.register_peer = RegisterPeer.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.register_peer_response = RegisterPeerResponse.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.punch_hole_request = PunchHoleRequest.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.punch_hole = PunchHole.decode(reader, reader.uint32());
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.punch_hole_sent = PunchHoleSent.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.punch_hole_response = PunchHoleResponse.decode(reader, reader.uint32());
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.fetch_local_addr = FetchLocalAddr.decode(reader, reader.uint32());
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.local_addr = LocalAddr.decode(reader, reader.uint32());
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.configure_update = ConfigUpdate.decode(reader, reader.uint32());
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.register_pk = RegisterPk.decode(reader, reader.uint32());
          continue;
        case 16:
          if (tag !== 130) {
            break;
          }

          message.register_pk_response = RegisterPkResponse.decode(reader, reader.uint32());
          continue;
        case 17:
          if (tag !== 138) {
            break;
          }

          message.software_update = SoftwareUpdate.decode(reader, reader.uint32());
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.request_relay = RequestRelay.decode(reader, reader.uint32());
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.relay_response = RelayResponse.decode(reader, reader.uint32());
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.test_nat_request = TestNatRequest.decode(reader, reader.uint32());
          continue;
        case 21:
          if (tag !== 170) {
            break;
          }

          message.test_nat_response = TestNatResponse.decode(reader, reader.uint32());
          continue;
        case 22:
          if (tag !== 178) {
            break;
          }

          message.peer_discovery = PeerDiscovery.decode(reader, reader.uint32());
          continue;
        case 23:
          if (tag !== 186) {
            break;
          }

          message.online_request = OnlineRequest.decode(reader, reader.uint32());
          continue;
        case 24:
          if (tag !== 194) {
            break;
          }

          message.online_response = OnlineResponse.decode(reader, reader.uint32());
          continue;
        case 25:
          if (tag !== 202) {
            break;
          }

          message.key_exchange = KeyExchange.decode(reader, reader.uint32());
          continue;
        case 26:
          if (tag !== 210) {
            break;
          }

          message.hc = HealthCheck.decode(reader, reader.uint32());
          continue;
        case 27:
          if (tag !== 218) {
            break;
          }

          message.http_proxy_request = HttpProxyRequest.decode(reader, reader.uint32());
          continue;
        case 28:
          if (tag !== 226) {
            break;
          }

          message.http_proxy_response = HttpProxyResponse.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RendezvousMessage {
    return {
      register_peer: isSet(object.register_peer) ? RegisterPeer.fromJSON(object.register_peer) : undefined,
      register_peer_response: isSet(object.register_peer_response)
        ? RegisterPeerResponse.fromJSON(object.register_peer_response)
        : undefined,
      punch_hole_request: isSet(object.punch_hole_request)
        ? PunchHoleRequest.fromJSON(object.punch_hole_request)
        : undefined,
      punch_hole: isSet(object.punch_hole) ? PunchHole.fromJSON(object.punch_hole) : undefined,
      punch_hole_sent: isSet(object.punch_hole_sent) ? PunchHoleSent.fromJSON(object.punch_hole_sent) : undefined,
      punch_hole_response: isSet(object.punch_hole_response)
        ? PunchHoleResponse.fromJSON(object.punch_hole_response)
        : undefined,
      fetch_local_addr: isSet(object.fetch_local_addr) ? FetchLocalAddr.fromJSON(object.fetch_local_addr) : undefined,
      local_addr: isSet(object.local_addr) ? LocalAddr.fromJSON(object.local_addr) : undefined,
      configure_update: isSet(object.configure_update) ? ConfigUpdate.fromJSON(object.configure_update) : undefined,
      register_pk: isSet(object.register_pk) ? RegisterPk.fromJSON(object.register_pk) : undefined,
      register_pk_response: isSet(object.register_pk_response)
        ? RegisterPkResponse.fromJSON(object.register_pk_response)
        : undefined,
      software_update: isSet(object.software_update) ? SoftwareUpdate.fromJSON(object.software_update) : undefined,
      request_relay: isSet(object.request_relay) ? RequestRelay.fromJSON(object.request_relay) : undefined,
      relay_response: isSet(object.relay_response) ? RelayResponse.fromJSON(object.relay_response) : undefined,
      test_nat_request: isSet(object.test_nat_request) ? TestNatRequest.fromJSON(object.test_nat_request) : undefined,
      test_nat_response: isSet(object.test_nat_response)
        ? TestNatResponse.fromJSON(object.test_nat_response)
        : undefined,
      peer_discovery: isSet(object.peer_discovery) ? PeerDiscovery.fromJSON(object.peer_discovery) : undefined,
      online_request: isSet(object.online_request) ? OnlineRequest.fromJSON(object.online_request) : undefined,
      online_response: isSet(object.online_response) ? OnlineResponse.fromJSON(object.online_response) : undefined,
      key_exchange: isSet(object.key_exchange) ? KeyExchange.fromJSON(object.key_exchange) : undefined,
      hc: isSet(object.hc) ? HealthCheck.fromJSON(object.hc) : undefined,
      http_proxy_request: isSet(object.http_proxy_request)
        ? HttpProxyRequest.fromJSON(object.http_proxy_request)
        : undefined,
      http_proxy_response: isSet(object.http_proxy_response)
        ? HttpProxyResponse.fromJSON(object.http_proxy_response)
        : undefined,
    };
  },

  toJSON(message: RendezvousMessage): unknown {
    const obj: any = {};
    if (message.register_peer !== undefined) {
      obj.register_peer = RegisterPeer.toJSON(message.register_peer);
    }
    if (message.register_peer_response !== undefined) {
      obj.register_peer_response = RegisterPeerResponse.toJSON(message.register_peer_response);
    }
    if (message.punch_hole_request !== undefined) {
      obj.punch_hole_request = PunchHoleRequest.toJSON(message.punch_hole_request);
    }
    if (message.punch_hole !== undefined) {
      obj.punch_hole = PunchHole.toJSON(message.punch_hole);
    }
    if (message.punch_hole_sent !== undefined) {
      obj.punch_hole_sent = PunchHoleSent.toJSON(message.punch_hole_sent);
    }
    if (message.punch_hole_response !== undefined) {
      obj.punch_hole_response = PunchHoleResponse.toJSON(message.punch_hole_response);
    }
    if (message.fetch_local_addr !== undefined) {
      obj.fetch_local_addr = FetchLocalAddr.toJSON(message.fetch_local_addr);
    }
    if (message.local_addr !== undefined) {
      obj.local_addr = LocalAddr.toJSON(message.local_addr);
    }
    if (message.configure_update !== undefined) {
      obj.configure_update = ConfigUpdate.toJSON(message.configure_update);
    }
    if (message.register_pk !== undefined) {
      obj.register_pk = RegisterPk.toJSON(message.register_pk);
    }
    if (message.register_pk_response !== undefined) {
      obj.register_pk_response = RegisterPkResponse.toJSON(message.register_pk_response);
    }
    if (message.software_update !== undefined) {
      obj.software_update = SoftwareUpdate.toJSON(message.software_update);
    }
    if (message.request_relay !== undefined) {
      obj.request_relay = RequestRelay.toJSON(message.request_relay);
    }
    if (message.relay_response !== undefined) {
      obj.relay_response = RelayResponse.toJSON(message.relay_response);
    }
    if (message.test_nat_request !== undefined) {
      obj.test_nat_request = TestNatRequest.toJSON(message.test_nat_request);
    }
    if (message.test_nat_response !== undefined) {
      obj.test_nat_response = TestNatResponse.toJSON(message.test_nat_response);
    }
    if (message.peer_discovery !== undefined) {
      obj.peer_discovery = PeerDiscovery.toJSON(message.peer_discovery);
    }
    if (message.online_request !== undefined) {
      obj.online_request = OnlineRequest.toJSON(message.online_request);
    }
    if (message.online_response !== undefined) {
      obj.online_response = OnlineResponse.toJSON(message.online_response);
    }
    if (message.key_exchange !== undefined) {
      obj.key_exchange = KeyExchange.toJSON(message.key_exchange);
    }
    if (message.hc !== undefined) {
      obj.hc = HealthCheck.toJSON(message.hc);
    }
    if (message.http_proxy_request !== undefined) {
      obj.http_proxy_request = HttpProxyRequest.toJSON(message.http_proxy_request);
    }
    if (message.http_proxy_response !== undefined) {
      obj.http_proxy_response = HttpProxyResponse.toJSON(message.http_proxy_response);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RendezvousMessage>, I>>(base?: I): RendezvousMessage {
    return RendezvousMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RendezvousMessage>, I>>(object: I): RendezvousMessage {
    const message = createBaseRendezvousMessage();
    message.register_peer = (object.register_peer !== undefined && object.register_peer !== null)
      ? RegisterPeer.fromPartial(object.register_peer)
      : undefined;
    message.register_peer_response =
      (object.register_peer_response !== undefined && object.register_peer_response !== null)
        ? RegisterPeerResponse.fromPartial(object.register_peer_response)
        : undefined;
    message.punch_hole_request = (object.punch_hole_request !== undefined && object.punch_hole_request !== null)
      ? PunchHoleRequest.fromPartial(object.punch_hole_request)
      : undefined;
    message.punch_hole = (object.punch_hole !== undefined && object.punch_hole !== null)
      ? PunchHole.fromPartial(object.punch_hole)
      : undefined;
    message.punch_hole_sent = (object.punch_hole_sent !== undefined && object.punch_hole_sent !== null)
      ? PunchHoleSent.fromPartial(object.punch_hole_sent)
      : undefined;
    message.punch_hole_response = (object.punch_hole_response !== undefined && object.punch_hole_response !== null)
      ? PunchHoleResponse.fromPartial(object.punch_hole_response)
      : undefined;
    message.fetch_local_addr = (object.fetch_local_addr !== undefined && object.fetch_local_addr !== null)
      ? FetchLocalAddr.fromPartial(object.fetch_local_addr)
      : undefined;
    message.local_addr = (object.local_addr !== undefined && object.local_addr !== null)
      ? LocalAddr.fromPartial(object.local_addr)
      : undefined;
    message.configure_update = (object.configure_update !== undefined && object.configure_update !== null)
      ? ConfigUpdate.fromPartial(object.configure_update)
      : undefined;
    message.register_pk = (object.register_pk !== undefined && object.register_pk !== null)
      ? RegisterPk.fromPartial(object.register_pk)
      : undefined;
    message.register_pk_response = (object.register_pk_response !== undefined && object.register_pk_response !== null)
      ? RegisterPkResponse.fromPartial(object.register_pk_response)
      : undefined;
    message.software_update = (object.software_update !== undefined && object.software_update !== null)
      ? SoftwareUpdate.fromPartial(object.software_update)
      : undefined;
    message.request_relay = (object.request_relay !== undefined && object.request_relay !== null)
      ? RequestRelay.fromPartial(object.request_relay)
      : undefined;
    message.relay_response = (object.relay_response !== undefined && object.relay_response !== null)
      ? RelayResponse.fromPartial(object.relay_response)
      : undefined;
    message.test_nat_request = (object.test_nat_request !== undefined && object.test_nat_request !== null)
      ? TestNatRequest.fromPartial(object.test_nat_request)
      : undefined;
    message.test_nat_response = (object.test_nat_response !== undefined && object.test_nat_response !== null)
      ? TestNatResponse.fromPartial(object.test_nat_response)
      : undefined;
    message.peer_discovery = (object.peer_discovery !== undefined && object.peer_discovery !== null)
      ? PeerDiscovery.fromPartial(object.peer_discovery)
      : undefined;
    message.online_request = (object.online_request !== undefined && object.online_request !== null)
      ? OnlineRequest.fromPartial(object.online_request)
      : undefined;
    message.online_response = (object.online_response !== undefined && object.online_response !== null)
      ? OnlineResponse.fromPartial(object.online_response)
      : undefined;
    message.key_exchange = (object.key_exchange !== undefined && object.key_exchange !== null)
      ? KeyExchange.fromPartial(object.key_exchange)
      : undefined;
    message.hc = (object.hc !== undefined && object.hc !== null) ? HealthCheck.fromPartial(object.hc) : undefined;
    message.http_proxy_request = (object.http_proxy_request !== undefined && object.http_proxy_request !== null)
      ? HttpProxyRequest.fromPartial(object.http_proxy_request)
      : undefined;
    message.http_proxy_response = (object.http_proxy_response !== undefined && object.http_proxy_response !== null)
      ? HttpProxyResponse.fromPartial(object.http_proxy_response)
      : undefined;
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
